import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  GetUnit_unit_unitConsumables as GetUnitConsumables,
  GetUnit as GetUnitGenerated,
  GetUnitVariables as GetUnitVariablesGenerated,
} from "core/queries/__generated__/GetUnitConsumables";

export interface GetUnitConsumablesResponse extends GetUnitGenerated {}
export interface GetUnitConsumablesVariables
  extends GetUnitVariablesGenerated {}
export interface UnitConsumables extends GetUnitConsumables {}

export const getUnitConsumables = gql`
  query GetUnit($id: ID!) {
    unit(id: $id) {
      id
      name
      unitConsumables {
        name
        nameLocalized
        group
        groupLocalized
        note
        noteLocalized
        suggestedMaxQuantity
        metadataKey
      }
    }
  }
`;

export interface UseGetUnitConsumablesQueryOptions {
  skip?: boolean;
  variables: GetUnitConsumablesVariables;
}

export const useGetUnitConsumablesQuery = ({
  skip = false,
  variables,
}: UseGetUnitConsumablesQueryOptions) =>
  useQuery<GetUnitConsumablesResponse, GetUnitConsumablesVariables>(
    getUnitConsumables,
    {
      skip,
      variables,
    },
  );
